import React, { forwardRef } from "react";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid"; // a plugin!
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import "assets/css/ServiceScheduler.css";
import Avatar from "components/avatar";

const EventCard = (data) => {
  return (
    <>
      <div
        data-id={data?.event?.id}
        className="event-card border-2 box-border border-[transparent] flex flex-col gap-1 p-2 2xl:p-3 4xl:p-3 w-full h-full rounded-xl content-center overflow-hidden"
      >
        <div className="flex-1">
          <p className="text-xs 4xl:text-sm font-medium text-gray-800 mb-1 truncate">
            {data?.event?.title}
          </p>
          <p className="text-xs 4xl:text-sm font-normal text-[#8F9BBA] dark:text-navy-900 overflow-hidden">
            {data?.event?.extendedProps?.origin?.type},{" "}
            {/* <span className="text-nowrap">{data?.timeText}</span> */}
          </p>
          <span className="text-xs 4xl:text-sm font-normal text-[#8F9BBA] dark:text-navy-900 overflow-hidden">
            {`${new Date(data?.event?.start).toLocaleTimeString([], {
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })} - ${new Date(data?.event?.end).toLocaleTimeString([], {
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })}`}
            {/* {data?.timeText
              ?.split("-")
              ?.map((t) => {
                const [hour, minute] = t.trim().split(":");
                const paddedHour = hour.padStart(2, "0");
                const paddedTime = `${paddedHour}:${minute || "00"}`;
                const date = new Date(`1970-01-01T${paddedTime}:00`);
                return date.toLocaleTimeString([], {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                });
              })
              .join(" - ")} */}
          </span>
        </div>

        <div className="flex flex-row flex-wrap justify-start truncate">
          {data?.event?.extendedProps?.origin?.users
            ?.slice(0, 3)
            .map((user) => (
              <div
                key={`event-user${user?.id}`}
                className="-mr-2 rounded-full border border-white dark:!border-white"
              >
                <Avatar
                  key={`avatar${user?.id}`}
                  user={user}
                  size="sm"
                  noBorder={true}
                />
              </div>
            ))}
          {data?.event?.extendedProps?.origin?.users?.length > 3 && (
            <div className="-mr-2 w-10 h-10 rounded-full bg-white border-2 border-gray-100 text-gray-800">
              <div
                className={`rounded-full w-fll h-full m-auto text-center flex items-center`}
              >
                <div className="flex-1 font-medium uppercase text-sm font-bold">
                  +{data?.event?.extendedProps?.origin?.users?.length - 3}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const EventCalendar = forwardRef(function (props, ref) {
  const { calendarData, initialDate, ...others } = props;

  return (
    <FullCalendar
      ref={ref}
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView="timeGridWeek"
      contentHeight="auto"
      events={calendarData}
      initialDate={initialDate}
      headerToolbar={false}
      titleFormat={{ year: "numeric", month: "long", day: "numeric" }}
      height="100%"
      allDaySlot={false}
      eventContent={EventCard}
      editable={false}
      selectable={true}
      eventMinHeight={130}
      firstDay={1}
      dayHeaderFormat={{ weekday: "short" }}
      dayHeaderContent={(data) => {
        return (
          <>
            <span className="inline-block content-center text-sm text-gray-700 font-normal pr-2 min-h-8">
              {data?.text}
            </span>
            <span
              className={`inline-block text-sm text-gray-800 font-bold dark:text-white ${
                data?.isToday &&
                "text-white bg-brand-600 w-6 h-6 content-center rounded-full"
              }`}
            >
              {data?.date?.getDate()}
            </span>
          </>
        );
      }}
      slotLabelFormat={{
        hour: "2-digit",
        minute: "2-digit",
        omitZeroMinute: false,
        meridiem: "uppercase",
      }}
      slotLabelClassNames="text-sm font-bold text-gray-800 dark:text-white"
      slotDuration="00:30:00"
      slotMinTime="00:00:00"
      slotMaxTime="24:00:00"
      {...others}
    />
  );
});

export default EventCalendar;
